export default __webpack_public_path__ + "static/media/wrong.3ee49855.wav";